import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { DspStrategyService } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspCustomCreativesComponent } from "@m19-board/dsp/dsp-creatives/dsp-custom-creatives/dsp-custom-creatives.component";
import { DspRejectedAdsBadgeComponent } from "@m19-board/dsp/dsp-creatives/dsp-rejected-ads/dsp-rejected-ads-badge.component";
import { DspResponsiveEcommerceComponent } from "@m19-board/dsp/dsp-creatives/dsp-responsive-ecommerce/dsp-responsive-ecommerce.component";
import { StrategyPageDspVideoComponent } from "@m19-board/dsp/dsp-creatives/dsp-video/strategy-page-dsp-video.component";
import { StrategyPageService } from "@m19-board/strategies/strategy-page/strategy-page.service";
import { IBadgeComponent } from "@front/m19-ui";

@Component({
  selector: "app-dsp-creatives",
  standalone: true,
  imports: [
    DspResponsiveEcommerceComponent,
    TranslocoDirective,
    DspCustomCreativesComponent,
    StrategyPageDspVideoComponent,
    DspRejectedAdsBadgeComponent,
    IBadgeComponent,
  ],
  templateUrl: "./strategy-page-dsp-creatives.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageDspCreativesComponent {
  private readonly strategyPageService = inject(StrategyPageService);

  readonly dspAdvertiserId = computed(() => this.strategyPageService.accountMarketplace().dspAdvertiserId!);
  readonly strategyId = computed(() => this.strategyPageService.strategy()!.strategyId);

  readonly isVideoEnabled = computed(
    () =>
      !!this.strategyPageService.strategy() &&
      DspStrategyService.isDspVideoStrategy(this.strategyPageService.strategy()!),
  );
}
